module.exports = __webpack_public_path__ + "static/media/PHOTO2.5e48d59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PHOTO2.png
// module id = 263
// module chunks = 0